import { useMatch } from 'react-router';

/**
 * Because the <SignupNanoBanner /> component is rendered in the <App /> component,
 * we need to check if the route is whitelisted for rendering the <SignupNanoBanner /> component.
 * @example const isSignupNanoBannerRoute = useIsSignupNanoBannerRoute();
 * @returns {boolean}
 */
function useIsSignupNanoBannerRoute() {
    const isJoinRoute = !!useMatch('/join/*');
    const isAcquisitionPDPRoute = !!useMatch('/:slug/p');
    const isRegistrationRoute = !!useMatch('/join/registration/*');

    return isJoinRoute || isAcquisitionPDPRoute || isRegistrationRoute;
}

export { useIsSignupNanoBannerRoute };
